import React, { useLayoutEffect } from 'react';
import { Button, FormGroup, InputGroupText } from 'reactstrap';
import { change, Field, Form, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from '../../../common/forms/select/Select';
import CostCenterSelect from '../../../common/forms/select/CostCenterSelect';
import { isRequired } from '../../../../utils/validators';
import {
  clearUsers,
  getExpenseAuthorizerUserByCostCenter,
} from '../../../../actions';
import FormItem from '../../../common/forms/FormItem';
import { CURRENCY } from '../../../../config/locale';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import ExpenseTypeSelect from '../../../common/forms/select/ExpenseTypeSelect';

const RefundParcelForm = ({
  initialValues,
  handleSubmit,
  onCancel,
  userOptions,
  dispatchChange,
  dispatchClearUsers,
  dispatchGetExpenseAuthorizerUserByCostCenter,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearUsers();
    },
    [],
  );

  const handleCostCenterChange = async (costCenterOption) => {
    const costCenterId = costCenterOption.value;
    if (costCenterId) {
      dispatchChange('CargoItemRefundModal', 'authorizerUserId', null);

      await dispatchGetExpenseAuthorizerUserByCostCenter({ costCenterId });
    }
  };
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup row className="mt-4">
          <FormItem label="Tipo de Egreso" required>
            <Field
              name="expenseTypeId"
              component={ExpenseTypeSelect}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Centro de Costos" required>
            <Field
              name="costCenterId"
              component={CostCenterSelect}
              onChange={handleCostCenterChange}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Autorizador" required>
            <Field
              name="authorizerUserId"
              component={Select}
              options={userOptions}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row className="mt-4">
          <FormItem label="Descripción">
            <Field name="description" component={TextInput} type="textarea" />
          </FormItem>
        </FormGroup>
        <FormGroup row className="mt-4">
          <FormItem label="Monto" required>
            <Field
              name="amount"
              component={TextInput}
              type="number"
              append={<InputGroupText>{CURRENCY}</InputGroupText>}
              disabled
            />
          </FormItem>
        </FormGroup>
        <FormFooter>
          <Button color="warning" onClick={onCancel}>
            Cancelar
          </Button>
        </FormFooter>
      </Form>
    </>
  );
};

RefundParcelForm.propTypes = {
  initialValues: PropTypes.instanceOf(Object).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  userOptions: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatchClearUsers: PropTypes.func.isRequired,
  dispatchGetExpenseAuthorizerUserByCostCenter: PropTypes.func.isRequired,
  dispatchChange: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchGetExpenseAuthorizerUserByCostCenter:
    getExpenseAuthorizerUserByCostCenter,
  dispatchClearUsers: clearUsers,
  dispatchChange: change,
};

const mapStateToProps = (state) => ({
  userOptions: state.UserUnit.User.getIn(['all', 'content', 'content']).map(
    (user) => ({
      value: user.userId,
      label: user.fullName,
    }),
  ),
});

const formComponent = reduxForm({
  form: 'RefunParcelForm',
})(RefundParcelForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
